import React from "react";
import { child, get, ref, set, update } from "firebase/database";
import { db } from "../../firebase";
import { getCookie } from "../cookie/cookie";

async function getPaidStatus() {
  let user = null;
  user = getCookie("user").split("@")[0];
  // if(user?.includes("_prod")){
  //   user = user.split("_prod")[0] + "-prod";
  // }
  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, user));
  return snapshot.exists();
}



async function getFunnelOptimizerStatus() {
  let user = null;
  user = getCookie("user").split("@")[0];
  // if(user?.includes("_prod")){
  //   user = user.split("_prod")[0] + "-prod";
  // }
  let url = `${user}/graph-status/funnel_optimizer`;
  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, url));
  const snapshotData = snapshot.val();
  return snapshotData;
}

async function setPersonaStatus(status) {
  let user = null;
  user = getCookie("user").split("@")[0];
  // if(user?.includes("_prod")){
  //   user = user.split("_prod")[0] + "-prod";
  // }
  let url = `${user}/graph-status/persona_status`;
  const snapshot = await set(
    ref(db, `${user}/graph-status/persona_status`),
    status
  );
}



async function visitorsBoughtTitle() {
  let user = null;
  user = getCookie("user").split("@")[0];
  // if(user?.includes("_prod")){
  //   user = user.split("_prod")[0] + "-prod";
  // }
  let url = `${user}/graph-uniqueSalesDone/graph-options/label`;
  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, url));
  const snapshotData = snapshot.val();
  // console.log("snapshotData", snapshotData);
  return snapshotData;
}

async function getPersonaStatus() {
  let user = null;
  user = getCookie("user").split("@")[0];
  // if(user?.includes("_prod")){
  //   user = user.split("_prod")[0] + "-prod";
  // }
  let url = `${user}/graph-status/persona_status`;
  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, url));
  const snapshotData = snapshot.val();
  // console.log("snapshotData", snapshotData);
  return snapshotData;
}

export {
  getPaidStatus,
  getPersonaStatus,
  setPersonaStatus,
  visitorsBoughtTitle,
  getFunnelOptimizerStatus
};
